/**
 * Configuration for the guided printer cleaning process.
 *
 * YouTube video: Set PRINTER_CLEANING_VIDEO_URL to the full YouTube URL.
 * For each step, set videoTimestampSeconds (start) and optionally videoTimestampEndSeconds (end)
 * to show "Von X:XX bis Y:YY" and link to the correct position in the video.
 */
export const PRINTER_CLEANING_VIDEO_URL = 'https://www.youtube.com/watch?v=WPJmaQflE3M';

export const PRINTER_CLEANING_STEPS = [
  {
    id: 'open-flap',
    shortLabel: 'Klappe öffnen',
    label: 'Klappe öffnen',
    videoTimestampSeconds: 0,
    videoTimestampEndSeconds: 5,
  },  
  {
    id: 'remove-ribbon',
    shortLabel: 'Farbband',
    label: 'Farbband herausnehmen',
    videoTimestampSeconds: 5,
    videoTimestampEndSeconds: 8,
  },
  {
    id: 'close-flap',
    shortLabel: 'Klappe schließen',
    label: 'Klappe schließen',
    videoTimestampSeconds: 9,
    videoTimestampEndSeconds: 12,
  },
  {
    id: 'slider-max',
    shortLabel: 'Regler einstellen',
    label: 'Schieberegler auf das Maximum stellen',
    videoTimestampSeconds: 13,
    videoTimestampEndSeconds: 24,
  },
  {
    id: 'remove-film',
    shortLabel: 'Folie abziehen',
    label: 'Plastikfolie von Reinigungskarte abziehen',
    videoTimestampSeconds: 29,
    videoTimestampEndSeconds: 33,
  },
  {
    id: 'insert-card',
    shortLabel: 'Reinigungskarte einlegen',
    label: 'Reinigungskarte mit der Klebeseite nach oben einlegen',
    videoTimestampSeconds: 33,
    videoTimestampEndSeconds: 36,
  },
];

export const PRINTER_CLEANING_WAITING_SEGMENT = {
  id: 'cleaning-wait',
  label: 'Reinigung läuft',
  videoTimestampSeconds: 36,
  videoTimestampEndSeconds: 55,
};

export const PRINTER_CLEANING_ROLLBACK_STEPS = [
  {
    id: 'slider-original',
    shortLabel: 'Regler zurück',
    label: 'Schieberegler auf ursprüngliche Position stellen',
    videoTimestampSeconds: 55,
    videoTimestampEndSeconds: 60,
  },
  {
    id: 'open-flap-rollback',
    shortLabel: 'Klappe öffnen',
    label: 'Klappe öffnen',
    videoTimestampSeconds: 63,
    videoTimestampEndSeconds: 68,
  },
  {
    id: 'insert-ribbon',
    shortLabel: 'Farbband',
    label: 'Farbband wieder einsetzen',
    videoTimestampSeconds: 69,
    videoTimestampEndSeconds: 72,
  },
  {
    id: 'close-flap-final',
    shortLabel: 'Klappe schließen',
    label: 'Klappe schließen',
    videoTimestampSeconds: 72,
    videoTimestampEndSeconds: 76,
  },
];
